import { Link } from "@tanstack/react-router";
import { TriangleAlertIcon } from "@/components/icons";
import { Skeleton } from "@/components/kit";
import { formatQtyWithUnit } from "@/modules/products/domain/unit-conversion";
import { useStockWithoutLotQuery } from "../api/queries";

type StockWithoutLotAlertProps = {
  limit?: number;
  className?: string;
};

export function StockWithoutLotAlert({
  limit = 5,
  className,
}: StockWithoutLotAlertProps) {
  const summary = useStockWithoutLotQuery(limit);

  if (summary.isLoading) {
    return <Skeleton className={`h-20 rounded-2xl ${className ?? ""}`} />;
  }

  const data = summary.data;
  if (!data || data.variantCount === 0) {
    return null;
  }

  return (
    <div
      className={`brand-card flex flex-col gap-3 border-destructive/25 bg-destructive/5 p-4 ${className ?? ""}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-destructive/15 text-destructive">
          <TriangleAlertIcon />
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-medium text-sm">
            ສະຕັອກ {data.totalWithoutLotQuantity} ຊິ້ນ ບໍ່ມີ lot ({data.variantCount}{" "}
            variant)
          </p>
          <p className="mt-0.5 text-muted-foreground text-xs">
            COGS ອາດບໍ່ຖືກຕ້ນທຸນ — ກົດລາຍການເພື່ອຈັດເຂົ້າ lot
          </p>
        </div>
      </div>

      {data.preview.length > 0 ? (
        <ul className="flex flex-col gap-1.5 text-xs">
          {data.preview.map((row) => (
            <li key={row.variantId}>
              <Link
                to="/app/products/$id/stock"
                params={{ id: row.productId }}
                search={{ variantId: row.variantId, assign: true }}
                className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-destructive/15 bg-background/60 px-3 py-2 transition-colors hover:border-destructive/35 hover:bg-background"
              >
                <span className="truncate">
                  {row.productName} · {row.variantName}
                </span>
                <span className="shrink-0 text-destructive tabular-nums">
                  {formatQtyWithUnit(row.withoutLotQuantity, row.stockUnitLabel)}{" "}
                  ບໍ່ມີ lot
                </span>
              </Link>
            </li>
          ))}
        </ul>
      ) : null}

      <Link
        to="/app/products"
        className="text-secondary text-sm underline-offset-2 hover:underline"
      >
        ເບິ່ງສິນຄ້າທັງໝົດ
      </Link>
    </div>
  );
}
